import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Offer } from '../../../shared/models/offers.model';
import { buildHttpParams } from '../../../shared/utils';
import { BaseApiService } from '../../../services/base-api/base-api.service';
import { buildApiUrl } from '../../../shared/utils';
import { API_ENDPOINTS } from '../../../shared/constants';

@Injectable({
  providedIn: 'root',
})
export class SuperOffersService extends BaseApiService {
  private readonly endpoint = buildApiUrl(
    environment.nmViajesApiUrl,
    API_ENDPOINTS.CONFIGURATIONS,
    'flight'
  );

  fetchTopFlightOffers() {
    const url = `${this.endpoint}/getMostWanted`;
    const params = buildHttpParams();
    const headers = new HttpHeaders({ 'not-loading': 'true' });
    return this.getApiList<Offer>(url, params, headers);
  }
}
